import { useMemo } from "react";
import { useOrganization } from "@/contexts/OrganizationContext";

// Returns current org_id for the authenticated user.
// Now integrated with OrganizationContext for seamless switching.
export function useCurrentOrgId() {
  const { currentOrgId, loading, error } = useOrganization();

  // Memoizar o retorno para evitar re-renders desnecessários
  return useMemo(() => ({
    orgId: currentOrgId,
    loading,
    error
  }), [currentOrgId, loading, error]);
}

// Retorna só o orgId (string) do contexto.
//
// Antes este hook mantinha um espelho em useState guardado por um useRef mutado
// DURANTE o render. Esse padrão é impuro: nos re-renders do boot (o
// OrganizationContext chega a resetar currentOrgId para null antes de resolver),
// o ref avançava para o org novo num render cujo setState acabava descartado,
// deixando currentOrgId === stableRef mas o estado espelhado preso em null —
// e o consumidor (ex.: sidebar) recebia orgId=null para sempre, sem nunca
// disparar o fetch de páginas. Como orgId é uma string comparada por valor, os
// deps de useEffect/useCallback a jusante já só reagem à mudança de valor;
// devolver currentOrgId direto é estável e correto, sem o ref frágil.
export function useOrgId(): string | null {
  const { currentOrgId } = useOrganization();
  return currentOrgId;
}
